import React from 'react';
import AppSuspense from '../AppSuspense';
import AppErrorBoundary from '../AppErrorBoundary';
import {StyledMainContentView} from './index.styled';
import {useLocaleContext} from '@erkport/context/AppContextProvider/LocaleContextProvider';

type AppContentViewProps = {
  routes: React.ReactElement | null;
};

const AppContentView: React.FC<AppContentViewProps> = ({routes}) => {
  const {locale} = useLocaleContext();

  return (
    <StyledMainContentView>
      <AppSuspense>
        <AppErrorBoundary>{routes}</AppErrorBoundary>
      </AppSuspense>
    </StyledMainContentView>
  );
};

export default AppContentView;
